// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1W53Z","select":"styles_select__1Ejax"};